import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.backgroundLighter};
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  align-items: flex-start;

  img {
    max-width: 100px;
    margin-right: 10px;
  }
`;

export default Container;
